import { isEmpty } from 'lodash-es';

const { __ } = wp.i18n;
const { withSelect, select } = wp.data;
const { compose } = wp.compose;
const { Fragment } = wp.element;
const { RichText } = wp.blockEditor;
const I18N_DOMAIN = 'ib-podcast';

const DisplayComponent = ({ meta, postType }) => {
	const postTypes = ['wow_podcast'];

	if (isEmpty(postType) || !postTypes.includes(postType)) {
		return null;
	}

	let podcastContent = meta?.podcast_content ? meta?.podcast_content : '';

	const updateMeta = metaKey => value => {
		wp.data.dispatch('core/editor').editPost({
			meta: {
				...meta,
				[metaKey]: value,
			},
		});
	};

	const setPodcastContent = e => {
		podcastContent = e;
		updateMeta('podcast_content')(podcastContent);
	};

	return (
		<Fragment>
			<>
				{
					<div>
						<RichText
							label={__('Podcast Content', I18N_DOMAIN)}
							placeholder={__('Podcast Content', I18N_DOMAIN)}
							onChange={value => setPodcastContent(value)}
							value={podcastContent}
						/>
					</div>
				}
			</>
		</Fragment>
	);
};

export default compose(
	withSelect(() => {
		const meta = select('core/editor').getEditedPostAttribute('meta');
		const currentPost = select('core/editor').getCurrentPost();
		return {
			meta,
			postType: currentPost?.type,
		};
	}),
)(DisplayComponent);
